import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import firebase from 'firebase'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

const config = require('./config')
const startSupportBadge = require('@/libs/support-badge').default

Vue.config.productionTip = false
Vue.prototype.$readerURL = config.baseURL
// Initialize Firebase
firebase.initializeApp(config.firebaseConfig)
startSupportBadge()

Vue.mixin({
  methods: {
    loader(show) {
      document.getElementById('loading-bg').style.display = show
    },
    formatDate(unixtimestamp) {
      if (unixtimestamp !== undefined && unixtimestamp !== null && !Number.isNaN(unixtimestamp)) {
        const a = new Date(unixtimestamp)
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const year = a.getFullYear()
        const month = months[a.getMonth()]
        const date = a.getDate()
        const hour = a.getHours()
        const min = a.getMinutes()
        const sec = a.getSeconds()
        return `${date} ${month} ${year} ${hour}:${min}:${sec}`
      }
      return unixtimestamp
    },
  },
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
